import { useUser } from 'vl-core/hooks/useUser';

export function useIsClinician() {
  const { user_type_code: userType } = useUser() || {};

  const clinicianRoleTypes = ['CLINICIAN', 'CLINAUDIT'];

  return clinicianRoleTypes.includes(userType);
}

export default useIsClinician;
